import { VideoCard as DesignSystemVideoCard } from '../../interaxDesignSystemComponents'
import { Video } from '../../types/VideoTypes'
import { ExpertVideo, VideoSource } from '../../../../pure-js/types/ExpertVideo'
import { TutorialVideo } from '../../../../pure-js/types/TutorialVideo'

interface VideoCardProps {
  video: Video | ExpertVideo | TutorialVideo
}

export default function VideoCard({ video }: VideoCardProps) {
  // Handle both old Video type and new ExpertVideo/TutorialVideo types
  const title = video.title
  const description = video.description
  const videoUrl = 'url' in video ? video.url : ''
  const videoSource: VideoSource = 'videoSource' in video && video.videoSource ? video.videoSource : 'youtube'
  // Pass undefined if videoLength doesn't exist or is empty, otherwise pass the value
  const videoLength = 'videoLength' in video && video.videoLength ? video.videoLength : undefined
  // Pass undefined if authors doesn't exist or is empty array, otherwise pass the array
  const authors = 'authors' in video && video.authors && video.authors.length > 0 ? video.authors : undefined

  // Only render if we have a valid video URL
  if (!videoUrl) {
    return null
  }

  return (
    <DesignSystemVideoCard
      title={title}
      description={description}
      videoUrl={videoUrl}
      videoSource={videoSource}
      videoLength={videoLength}
      authors={authors}
    />
  )
}
